import { RegistrationRoute } from "apps/registration/routes/route";
import Icon from "assets/icons";
import React from "react";
import { Link } from "react-router-dom";
import { CookieManager } from "shared/consentManagement/enum";
import { useRegDetail } from "shared/context/regDetail";
import { useCopies } from "shared/hooks/useCopies";
import { useDisplayBehaviour } from "../displayBehaviour/displayBehaviourProvider";
import { PERSONATECH_COOKIE_POLICY_URL, PERSONATECH_URL } from "shared/utils/constants";
import OpenLinkInNewTab from "shared/form/core/link";
import { RegistrationFooterContent } from "./utils";

export default function RegistrationFooter() {
  const copies = useCopies();
  const regDetail = useRegDetail();
  const { behaviour } = useDisplayBehaviour();
  const footerContentList = React.useMemo(() => {
    return behaviour.getRegistrationFooterContentList({
      registrationGdprConsentEnabled: regDetail?.registrationGdprConsentEnabled,
      displayPoweredBy: regDetail?.displayPoweredBy
    });
  }, [regDetail, behaviour]);

  if (footerContentList.length === 0) {
    return null;
  }

  return (
    <footer className="regFooter">
      <div className="poweredBy">
        {footerContentList.includes(RegistrationFooterContent.POWERED_BY) && (
          <React.Fragment>
            <em>{copies.get("powered.by")}</em>
            <OpenLinkInNewTab url={PERSONATECH_URL} title={PERSONATECH_URL}>
              <Icon.PersonatechDark />
            </OpenLinkInNewTab>
          </React.Fragment>
        )}
      </div>

      <div className="link">
        {footerContentList.includes(RegistrationFooterContent.COOKIES) && (
          <React.Fragment>
            {regDetail?.registrationGdprMetadata?.manager === CookieManager.ONE_TRUST && <CookiesLinkForOneTrust />}
            {regDetail?.registrationGdprMetadata?.manager === CookieManager.IN_HOUSE && <CookiesLinkForInhouse />}
          </React.Fragment>
        )}
      </div>
    </footer>
  );
}

function CookiesLinkForOneTrust() {
  const copies = useCopies();
  return <Link to={`${RegistrationRoute.Cookies}`}>{copies.get("cookies.link.name")}</Link>;
}

function CookiesLinkForInhouse() {
  const copies = useCopies();
  return (
    <a href={PERSONATECH_COOKIE_POLICY_URL} target="_blank" rel="noreferrer">
      {copies.get("cookies.link.name")}
    </a>
  );
}
